export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_10.b403645c.jpg";